function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useHistory } from 'react-router-dom';
import { useOverlayContext } from 'seagull/components/OverlayContext';
import { routes } from "../../../constants";
import { useIoContext } from "../../../contexts";
import { BusinessChannelEventBinder } from "../../../pusher/BusinessChannelEventBinder";
import { PusherEvent } from "../../../pusher/model";
import { selectors } from "../../../store/state-selectors";
import { useStore, useStoreActions } from "../../../store/store-context";
import { IntegrationStatus } from "../../../types/api.model";
import XeroLogo from "../../assets/XeroLogo";
import IntegrationCard from "../IntegrationCard/IntegrationCard";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
const connectionInProgressCardProps = () => {
  return {
    subTitle: 'Set up your Xero account connection.',
    mainAction: /*#__PURE__*/_jsx(IntegrationCard.MainActionButton, {
      loading: true,
      loadingText: "Connection in progress",
      "data-testid": "xero-card-connection-in-progress",
      children: "Connection in progress"
    })
  };
};
const connectCardProps = _ref => {
  let {
    handleConnect
  } = _ref;
  return {
    subTitle: 'Connect your account to sync between Anchor and Xero',
    mainAction: /*#__PURE__*/_jsx(IntegrationCard.MainActionButton, {
      "data-testid": "xero-card-connect-button",
      onClick: handleConnect,
      children: "Connect"
    })
  };
};
const manageCardProps = _ref2 => {
  let {
    companyName,
    handleManage
  } = _ref2;
  return {
    subTitle: "Set up your Xero account connection with ".concat(companyName),
    mainAction: /*#__PURE__*/_jsx(IntegrationCard.MainActionButton, {
      "data-testid": "xero-card-manage-button",
      onClick: handleManage,
      children: "Manage connection"
    })
  };
};
export default function XeroCard() {
  const {
    startLoader,
    stopLoader
  } = useOverlayContext();
  const {
    changeLocation
  } = useIoContext();
  const {
    api,
    fetchIntegrations,
    logBI
  } = useStoreActions();
  const history = useHistory();
  const xeroIntegrationInStore = useStore(selectors.integration.xeroIntegration);
  if (!xeroIntegrationInStore) {
    return null;
  }
  const handleConnect = async () => {
    logBI(18600);
    startLoader();
    const integration = await api.xero.connect({
      redirectUrl: "http://".concat(window.location.host).concat(routes.availableApps)
    });
    if (integration.linkUrl) {
      const connectUrl = new URL(integration.linkUrl);
      changeLocation(connectUrl.toString());
    } else {
      stopLoader();
    }
  };
  const handleManage = async () => {
    logBI(18601);
    history.push(routes.xeroSetup);
  };
  function onPusherIntegrationEvent() {
    fetchIntegrations();
  }
  const integrationCardProps = () => {
    switch (xeroIntegrationInStore.status) {
      case IntegrationStatus.Linked:
        {
          return xeroIntegrationInStore.isReady() ? manageCardProps({
            companyName: xeroIntegrationInStore.companyName() || 'your account',
            handleManage: handleManage
          }) : connectionInProgressCardProps();
        }
      case IntegrationStatus.Unlinked:
        {
          return connectCardProps({
            handleConnect
          });
        }
      default:
        {
          return connectCardProps({
            handleConnect
          });
        }
    }
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(BusinessChannelEventBinder, {
      source: "mgmt",
      eventName: PusherEvent.IntegrationEvent,
      callback: onPusherIntegrationEvent
    }), /*#__PURE__*/_jsx(IntegrationCard, _objectSpread({
      "data-testid": "xero-card",
      icon: /*#__PURE__*/_jsx(XeroLogo, {}),
      title: "Xero"
    }, integrationCardProps()))]
  });
}